import { Icon } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { ReactComponentLike } from 'prop-types';
import './CustomerSupportDetail.scss';

export interface ICustomerSupportDetailProps {
  svg: ReactComponentLike;
  title: string;
  subtitle: string;
  className?: string | object;
}

export default function CustomerSupportDetail({ svg, title, subtitle, className }: ICustomerSupportDetailProps) {
  return (
    <div className={classNames('customer-support-detail', className)}>
      <Icon svg={svg} size={64} />
      <HeaderText title={title}>{subtitle}</HeaderText>
    </div>
  );
}
